import type { StaticProductView } from 'state/product-description/types';
import type { AppState } from 'state/state.model';
import * as fromUser from 'state/user/user.selector';

export function getUserCompanyBdrId(state: AppState) {
  return fromUser.getUserCompanyBdrId(state.user);
}
export function getUserCompanyName(state: AppState) {
  return fromUser.getUserCompanyName(state.user);
}
export function getUserDefaultProductView(state: AppState): StaticProductView {
  const view = fromUser.getDefaultProductView(state.user);
  if (view === 'Batch') {
    return 'Batch';
  }

  return 'Default';
}

export function getIsUserInternal(state: AppState): boolean {
  return fromUser.isUserInternal(state.user);
}
const EMPTY: readonly [] = [];
export function getMailingLists(state: AppState) {
  return state.user.mailingLists ?? EMPTY;
}
export function getIsTraderUser(state: AppState): boolean | undefined {
  return fromUser.isTraderUser(state.user);
}

export * as fromUser from 'state/user/user.selector';
